import Vue from 'vue'

export const eventTypes = {
  streamAdded: 'gastro-stream-added',
  startTimer: 'gastro-timer-start',
  stopTimer: 'gastro-timer-stop',
}

export default new Vue()
